import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import _isNil from 'lodash/isNil';
import { IoChevronBackOutline } from 'react-icons/io5';

import { RootState } from '../../store';
import { updateSiteLanguage } from '../../store/reducer';
import { setValueInLocalStorage } from '../../utils/common';
import { languageList, routePathOptions } from '../../utils/contant';
import { useGetSiteConstantValue } from '../../utils/hooks/useGetSiteConstantValue';
import { IconWrapper, Text } from '../../ui-component';
import { DropdownField } from '../../components/FormComponents';

import { Container, HeaderInfo, Circle } from './style';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { pathname, search } = location;

  const { onboardingReducer, commonDataReducer } = useSelector((state: RootState) => state);
  const { boutiqueData } = onboardingReducer;
  const { enableHeaderBackButton } = commonDataReducer.headerData;

  const currLang = commonDataReducer.currLang;

  const { admin_tailor_name = '', admin_tailor_profile_pic_url = '' } = boutiqueData || {};

  const { getSiteConstantValue } = useGetSiteConstantValue();

  const getCurrentRoute = () => {
    return routePathOptions.filter((route) => {
      const currentPath = pathname.split('/')[1];

      if (route.path.includes(currentPath)) {
        return true;
      }

      return false;
    });
  };

  const getHeaderTitle = useMemo(() => {
    const currentRoute = getCurrentRoute();

    if (currentRoute.length > 0) {
      const searchParams = new URLSearchParams(search.substring(1));
      const pathFormType = searchParams.get('formType') ?? '';

      return !_isNil(currentRoute[0].formType) && !_isNil(currentRoute[0].formType[pathFormType])
        ? getSiteConstantValue('common', currentRoute[0].formType[pathFormType])
        : getSiteConstantValue('common', currentRoute[0].label);
    }

    return '';
  }, [pathname, search]);

  const currentRoute = getCurrentRoute();
  const showBack = currentRoute.length > 0 ? currentRoute[0].showBackIcon : false;

  const handleChangeLanguage = (obj: any) => {
    setValueInLocalStorage('currLang', obj);
    dispatch(updateSiteLanguage({ data: obj }));
  };

  return (
    <Container>
      <div className="title-container">
        {showBack && (
          <IconWrapper
            onClick={() => {
              if (enableHeaderBackButton) {
                navigate(-1);
              }
            }}
          >
            <IoChevronBackOutline id="header-back-icon" />
          </IconWrapper>
        )}
        <Text size="xl" fontWeight={700}>
          {getHeaderTitle}
        </Text>
      </div>
      <HeaderInfo>
        <DropdownField options={languageList} value={currLang} onChange={handleChangeLanguage} />
        <Circle>
          <img src={admin_tailor_profile_pic_url} alt="profile-pic" />
        </Circle>
        <Text fontWeight={600}>{admin_tailor_name}</Text>
      </HeaderInfo>
    </Container>
  );
};

export default Header;
